import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import { NewBaseUrl } from "axios/api";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import RequestDetailsPanel from "./components/RequestDetailsPanel";
import RequestsPagination from "./components/RequestsPagination";
import RequestsTable from "./components/RequestsTable";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  pageHeader: {
    marginBottom: theme.spacing(3),
    textAlign: "right",
  },
  subtitle: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
}));

const ROWS_PER_PAGE = 5;

export default function ListAuthRequests() {
  const classes = useStyles();

  // وضعیت لیست درخواست‌ها (برای امکان تایید/رد و به‌روزرسانی نمایش)
  const [requests, setRequests] = useState();

  // وضعیت فیلترها و جستجو
  const [searchValue, setSearchValue] = useState("");
  const [statusValue, setStatusValue] = useState("all");
  const [page, setPage] = useState(1);

  // درخواست انتخاب‌شده برای نمایش جزئیات (پنل زیر جدول باز می‌شود)
  const [selectedRequest, setSelectedRequest] = useState(null);

  const token = useSelector((state) => state.token);

  const getRequests = async (headers) => {
    try {
      const resRequests = await axios.get(`users?verified=true`, {
        baseURL: NewBaseUrl,
        headers: headers,
      });

      setRequests(resRequests.data.data);
      //   setUserAuthDetail(resUserDetail.data);
    } catch (e) {
      // dispatch(Loading());
    }
  };

  const getRequestDetail = async (headers, request) => {
    try {
      const res = await axios.get(`users/${request.id}`, {
        baseURL: NewBaseUrl,
        headers: headers,
      });

      setSelectedRequest(res.data);
    } catch (e) {}
  };

  useEffect(() => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-client-version": "8",
    };
    getRequests(headers);
  }, [token]);

  // فیلتر کردن درخواست‌ها بر اساس جستجو و وضعیت انتخاب‌شده
  const filteredRequests = useMemo(() => {
    return requests?.filter((request) => {
      const matchesStatus =
        statusValue === "all" || request.is_verified === statusValue;

      const searchLower = searchValue.trim().toLowerCase();
      const matchesSearch =
        searchLower === "" ||
        `${request.full_name}`.toLowerCase().includes(searchLower) ||
        request.nationalCode.includes(searchLower) ||
        request.phone.includes(searchLower);

      return matchesStatus && matchesSearch;
    });
  }, [requests, searchValue, statusValue]);

  const totalPages = Math.max(
    1,
    Math.ceil(filteredRequests?.length / ROWS_PER_PAGE)
  );

  const paginatedRequests = useMemo(() => {
    const start = (page - 1) * ROWS_PER_PAGE;
    return filteredRequests?.slice(start, start + ROWS_PER_PAGE);
  }, [filteredRequests, page]);

  const handleViewDetails = (request) => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-client-version": "8",
    };
    getRequestDetail(headers, request);
    // اگر روی همان ردیف دوباره کلیک شود، پنل بسته می‌شود؛ در غیر این صورت جزئیات همان ردیف باز می‌شود
  };

  const handleClosePanel = () => {
    setSelectedRequest(null);
  };

  const updateRequestStatus = (id, isAccept) => {
    setRequests((prev) => prev.filter((req) => req.id !== id));
    // setRequests((prev) =>
    //   prev.map((req) =>
    //     req.id === id ? { ...req, is_verified: isAccept ? 2 : 3 } : req
    //   )
    // );
    handleClosePanel();
  };

  const acceptOrRejectRequest = async (isAccept) => {
    const id = selectedRequest?.id;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-client-version": "8",
    };
    try {
      const res = await axios.post(
        `users/${id}`,
        { "is-verified": isAccept ? 2 : 3 },
        {
          baseURL: NewBaseUrl,
          headers: headers,
        }
      );
      // handleClosePanel();
    } catch (e) {}
  };

  const handleApprove = () => {
    const id = selectedRequest?.id;
    updateRequestStatus(id, true);
    acceptOrRejectRequest(true);
  };
  const handleReject = () => {
    const id = selectedRequest?.id;

    updateRequestStatus(id, false);
    acceptOrRejectRequest(false);
  };

  return (
    <Container maxWidth="xl" className={classes.root}>
      <div className={classes.pageHeader}>
        <Typography variant="h4">درخواست‌های احراز هویت کاربران</Typography>
      </div>

      {/* <FiltersToolbar
        searchValue={searchValue}
        onSearchChange={(value) => {
          setSearchValue(value);
          setPage(1);
        }}
        statusValue={statusValue}
        onStatusChange={(value) => {
          setStatusValue(value);
          setPage(1);
        }}
        dateRangeLabel="۱۴۰۳/۰۲/۰۱ - ۱۴۰۳/۰۳/۳۰"
      /> */}

      {paginatedRequests && (
        <RequestsTable
          requests={paginatedRequests}
          onViewDetails={handleViewDetails}
          selectedId={selectedRequest ? selectedRequest?.id : null}
          closeModal={() => setSelectedRequest(null)}
        />
      )}

      {Boolean(selectedRequest) && (
        <RequestDetailsPanel
          request={selectedRequest?.info}
          onClose={handleClosePanel}
          onApprove={handleApprove}
          onReject={handleReject}
          files={selectedRequest?.files}
          status={selectedRequest?.is_verified}
        />
      )}

      <RequestsPagination
        page={page}
        totalPages={totalPages}
        onPageChange={setPage}
      />
    </Container>
  );
}
